// import { izip } from './iterable';
// import { pipe, map, filter, flat, toArray, concat } from './pipeable-iterable';

// export function url(strings: TemplateStringsArray, ...expressions: any[]) {
//   return pipe(
//     izip(strings, expressions),
//     flat(),
//     concat([strings[strings.length - 1]]),
//     map(segment => String(segment).replace(/^\/*(.*?)\/*$/, '$1')),
//     filter(segment => !!segment),
//     toArray()
//   ).join('/');
// }

export function urlConverter(text){
  const linkHrefRegex = /<a\s+[^>]*href=["']([^"']+)["'][^>]*>(.*?)<\/a>/g;
  const [href, linkText] = text.split(linkHrefRegex).filter(Boolean);

  return <a href={href} key={href} title={href} target="_blank">{linkText || href}</a>;
}